
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/coupons",
      function () {
        return require("private-next-pages/customer-studio/coupons.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/coupons"])
      });
    }
  